import { render, staticRenderFns } from "./Foxintelligence.vue?vue&type=template&id=57990a27&scoped=true&"
import script from "./Foxintelligence.vue?vue&type=script&lang=js&"
export * from "./Foxintelligence.vue?vue&type=script&lang=js&"
import style0 from "./Foxintelligence.vue?vue&type=style&index=0&id=57990a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57990a27",
  null
  
)

component.options.__file = "Foxintelligence.vue"
export default component.exports